import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { CartIcon as CartIconSVG } from 'assets/icons/CartIcon';

export const CartIcon = () => (
  <div
    className={classNames(
      styles.cartIcon,
    )}
  >
    <CartIconSVG />
  </div>
);
